import { createSelector } from '@ngrx/store';

import { selectDecoratorsState } from './decorators.selector';

export const getCopyEnable = createSelector(
  selectDecoratorsState,
  ({ isCopyEnable }): boolean => isCopyEnable
);
